import { render, staticRenderFns } from "./MerchantHomepage.vue?vue&type=template&id=992845fe&scoped=true&"
import script from "./MerchantHomepage.vue?vue&type=script&lang=js&"
export * from "./MerchantHomepage.vue?vue&type=script&lang=js&"
import style0 from "./MerchantHomepage.vue?vue&type=style&index=0&id=992845fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992845fe",
  null
  
)

export default component.exports